import UIFacade from "../../UIFacade";
import SettingsPartContainer from "@baseUI/component/settings/SettingsPartContainer";
import ButtonDrawComponent from "@baseUI/component/button/ButtonDrawComponent";
import Facade from "@baseUI/UIFacade";
import UISignals from "@baseUI/controllers/UISignals";
import UICreatorComponent from "@baseUI/utils/UICreatorComponent";
import UICreatorText from "@baseUI/utils/UICreatorText";
import UICreatorGraphics from "@baseUI/utils/UICreatorGraphics";

export default class AutospinSettingsPartContainer extends SettingsPartContainer {

    constructor(params) {
        super(params)
        this.setParametersSizePosition(params)
        this.init()
    }
v

    init() {

        this.autospinData  = {
            indexAutoStopCount: -1,
            indexAutoStopBalanceLower: -1,
            indexAutoStopBalanceHigher: -1,
            indexAutoStopMoneyExceed: -1
        }

        const panelPopup = UICreatorComponent.addContainer(this, this.param.panelPopupPosition)
        //this.panelPopup = panelPopup
        UICreatorText.addElementTextName('popupAutoplayCaption_TEXT', panelPopup, this.param.popupAutoplayCaptionPosition)
        const panelAdditional = UICreatorComponent.addContainer(this, this.param.panelAdditionalPosition)
        panelPopup.addChild(panelAdditional)

        const lineTop = this.param.lineTop
        UICreatorGraphics.addLine(panelPopup, lineTop.x1, lineTop.y1, lineTop.x2, lineTop.y2)

        const lineMiddle = this.param.lineMiddle
        UICreatorGraphics.addLine(panelPopup, lineMiddle.x1, lineMiddle.y1, lineMiddle.x2, lineMiddle.y2)

        this.createPartCountNumbers(panelAdditional, this.param.createPartCountNumbers )
        this.createPartDependsBalance(panelAdditional)

        //settingPlay_BUTTON

        this.settingPlay = UICreatorComponent.addButton('settingPlay_BUTTON', this, this.param.settingPlayPosition )
        this.settingPlay.on('tapButton', () => {
            UISignals.startAutoplay.dispatch(this.autospinData)
            UISignals.setStateMenu.dispatch("closeMenu")
        })

    }

    createPartCountNumbers(panel, countRow){
        UICreatorText.addElementTextName('popupAutoplayRounds_TEXT', panel, this.param.popupAutoplayRoundsPosition)
        const settingsBtn = this.param.countNumbers.btn
        const listNumbers = UIFacade.model.autospinList
        this.btnNumberOfRounds =[]
            //['10','25','50','100','250', '1000']
        listNumbers.map((element, index)=>{
            const numberBtn = new ButtonDrawComponent( settingsBtn)
            panel.addChild(numberBtn)
            numberBtn.x = settingsBtn.startX + (settingsBtn.width + settingsBtn.spaceX ) * (index % countRow)
            numberBtn.y = settingsBtn.startY + (settingsBtn.height + settingsBtn.spaceY) * Math.floor(index/countRow)

            numberBtn.addText(element, 'systemTextButton')
            this.btnNumberOfRounds.push(numberBtn)
            //'autoplayNum'+element, 'autoplayNum'+element,
            numberBtn.on('tapButton', ()=>{
                this.autospinData.indexAutoStopCount = index
                this.btnNumberOfRounds.map((btn) => {
                    if (btn!==numberBtn) {btn.buttonSetStateTexture = 'up'}
                } )
            //    numberBtn.buttonSetStateTexture = 'down'
           })
        })
    }

    createPartDependsBalance(panel){

        const panelBalance = UICreatorComponent.addContainer(panel, this.param.panelBalance)
        UICreatorText.addElementTextName('popupAutoplaySettings_TEXT', panelBalance, this.param.popupAutoplaySettingsPosition)

        let settingsBtn = this.param.balanceLower.btn
        const textLower = UICreatorText.addElementTextName('popupAutoplayLower_TEXT', panelBalance, this.param.popupAutoplayLowerPosition)

        const listLower = Facade.model.autoStopBalanceLowerValues  //['0%','50%','75%']
        this.btnBalanceLowerValues = []
        listLower.map((element, index)=>{
            const button = new ButtonDrawComponent(settingsBtn)
            panelBalance.addChild(button)
            button.x = settingsBtn.startX + (settingsBtn.width + settingsBtn.spaceX ) * index
            button.y = settingsBtn.startY
            button.addText(element * 100 +'%', 'systemTextButton')
            this.btnBalanceLowerValues.push(button)
            button.on('tapButton', ()=>{
                this.autospinData.indexAutoStopBalanceLower = index
                this.btnBalanceLowerValues.map((btn) => {
                    if (btn!==button) {btn.buttonSetStateTexture = 'up'}
                } )
            })
        })

        const textHigher = UICreatorText.addElementTextName('popupAutoplayHigher_TEXT', panelBalance, this.param.popupAutoplayHigherPosition, )

        const listHeight = Facade.model.autoStopBalanceHigherValues//['150%','200%','500%']
        settingsBtn = this.param.balanceHigher.btn
        this.btnBalanceHigherValues = []
        listHeight.map((element, index)=>{
            const button = new ButtonDrawComponent(settingsBtn)
            panelBalance.addChild(button)
            button.x = settingsBtn.startX + (settingsBtn.width + settingsBtn.spaceX ) * index
            button.y = settingsBtn.startY
            button.addText(element * 100 +'%', 'systemTextButton')
            this.btnBalanceHigherValues.push(button)
            button.on('tapButton', ()=>{
                this.autospinData.indexAutoStopBalanceHigher = index
                this.btnBalanceHigherValues.map((btn) => {
                    if (btn!==button) {btn.buttonSetStateTexture = 'up'}
                })
            })
        })

    }

}
